import { defineStore } from 'pinia';
import { useApiFetch } from '~/composables/useApiFetch';
import type { Post } from '~/models/blog';

type PostsCache = {
  [key in 'cs' | 'en']: { loaded: boolean; data: Post[] };
};

export const useBlogStore = defineStore('blog', {
  state: () => ({
    loadingHomepagePosts: true,
    homepagePostsCache: {
      cs: { loaded: false, data: [] },
      en: { loaded: false, data: [] },
    } as PostsCache,
  }),
  getters: {
    homepagePosts: (state) => {
      const {
        $i18n: { locale },
      } = useNuxtApp();
      const language = locale.value as 'cs' | 'en';

      if (state.homepagePostsCache[language].loaded) {
        return state.homepagePostsCache[language].data;
      }

      return [];
    },
  },
  actions: {
    async getHomepagePosts({ force = false }: { force?: boolean }) {
      const {
        $i18n: { locale },
      } = useNuxtApp();
      const language = locale.value as 'cs' | 'en';
      const fetch = useApiFetch();

      if (this.homepagePostsCache[language].loaded && !force) {
        return this.homepagePostsCache[language].data;
      }

      this.loadingHomepagePosts = true;

      const posts = await fetch<Post[]>(
        'https://magazin.portu.cz/wp-json/wp/v2/posts?_embed&tags=442&tags_exclude=152&per_page=6&page=1',
      );

      this.homepagePostsCache[language] = {
        loaded: true,
        data: posts,
      };
      this.loadingHomepagePosts = false;

      return posts;
    },
  },
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useBlogStore, import.meta.hot));
}
